export default {
  en: {
    'components.summary-table.header.type': 'Type',
    'components.summary-table.header.tax-codes': 'Tax code',
    'components.summary-table.header.total-net': 'Total Net',
    'components.summary-table.header.total-vat': 'Total VAT',
    'components.summary-table.header.number-transactions': 'Transactions',
    'components.summary-table.header.errors': 'Errors',
    'components.summary-table.header.warnings': 'Warnings',
    'components.summary-table.header.status': 'Status',

    'components.summary-table.row.total': 'Total',

    'components.summary-table.transaction.output': 'Output transaction types',
    'components.summary-table.transaction.input': 'Input transaction types',
    'components.summary-table.transaction.blank': 'Missing transaction types',
    'components.summary-table.transaction.blank-type': 'Undefined',
  },
};
